import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import cx from 'classnames';
import { FormattedMessage, useIntl } from "react-intl"
import { flowRight as compose } from 'lodash';;
import { Field, formValueSelector, reduxForm } from "redux-form";
import { useSelector } from "react-redux";
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import withStyles from 'isomorphic-style-loader/withStyles';

// Utilities & Helpers
import history from "../../../core/history";
import messages from "../../../locale/jsonMessages";
import submit from "./submit";
import validate from "./validate";

// Components
import Loader from "../../Loader/Loader";
import StripeCardList from "../../Common/CommonPayment/Stripe/StripeCardList";
import PaypalPayment from "../../Common/CommonPayment/Paypal/PaypalPayment";

//Style
import cs from '../../../components/commonStyle.css'

const ServicePlansBookForm = (props) => {
    const { handleSubmit, submitting, error, userType, isCancel } = props;
    const { formatMessage } = useIntl();
    const [paymentStatus, setPaymentStatus] = useState(2);

    const available = (props.data || []).filter(method => !isCancel || method.paymentType === 1);
    useEffect(() => {
        const selected = available.some(method => method.paymentType === paymentStatus)
            ? paymentStatus : (available[0]?.paymentType || 0);
        setPaymentStatus(selected);
        props.change('paymentType', String(selected));
    }, [props.data, isCancel, paymentStatus]);

    const selector = formValueSelector("ServicePlansBookForm");
    const paymentCurrencyList = useSelector((state) => state?.currency?.availableCurrencies);

    const handleCancel = () => {
        history.push(`/users/service-plans/${userType}`);
    };

    const handlePayment = (e) => {
        const paymentType = e.target.value;
        setPaymentStatus(paymentType == 2 ? 2 : 1);
    };

    const renderFormControlSelect = ({ input, meta: { touched, error }, children, className, disabled }) => {
        return (
            <FormGroup className={cs.spaceBottom0}>
                <FormControl disabled={disabled} componentClass="select" {...input} className={className}>
                    {children}
                </FormControl>
                {touched && error && <span className={cs.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        );
    };

    return (
        <form onSubmit={handleSubmit((values, dispatch, formProps) => available.some(method => method.paymentType === Number(values.paymentType)) ? submit(values, dispatch, formProps) : undefined)}>
            <div className={cs.spaceBottom3}>
                <label><FormattedMessage {...messages.PaymentMethodText} /></label>
                <Field
                    name="paymentType"
                    type="text"
                    className='commonSelectField'
                    component={renderFormControlSelect}
                    onChange={handlePayment}
                >
                    {available.map(method => <option key={method.id} value={method.paymentType}>{method.paymentType === 2 ? formatMessage(messages.creditCard) : formatMessage(messages.payPal)}</option>)}
                </Field>
            </div>
            {available.length === 0 ? <p role="status">{formatMessage(messages.noPaymentFound)}</p> : paymentStatus === 2 && !isCancel ? (<StripeCardList error={error} />) : (<PaypalPayment paymentCurrencyList={paymentCurrencyList} />)}
            <div className={cx('doubleBtnFlexEnd', cs.spaceTop4)}>
                {!isCancel && <Button onClick={handleCancel} className={cs.btnPrimaryBorder}>
                    {formatMessage(messages.cancel)}
                </Button>}
                <Loader
                    type="button"
                    buttonType="submit"
                    className={cx(cs.btnPrimary, 'loaderButtonFlex')}
                    disabled={submitting || error || available.length === 0}
                    label={formatMessage(messages.payNow)}
                    show={submitting}
                />
            </div>
        </form>
    );
};

export default compose(
    withStyles(cs),
    reduxForm({
        form: 'ServicePlansBookForm',
        validate
    }))(ServicePlansBookForm);
